/*global loadImage*/
var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  var utils = {};

  utils.filters = {};
  utils.blenders = {};
  utils.webRTCSupported = !!navigator.getUserMedia && false;
  utils.STATE = {
    webcamEl: null,
    canvasEl: null,
    inputEl: null
  };
  utils.DEBUG_CANVAS = 'debug';

  utils.registerFilter = function (name, filter) {
    this.filters[name] = filter;
  };

  utils.getFilter = function (name) {
    return this.filters[name];
  };

  utils.getFilterNames = function () {
    return Object.keys(this.filters);
  };

  utils.doFilter = function (name, canvas, cb, config) {
    var filter = this.getFilter(name);

    canvas = canvas || this.getCanvas();

    if (filter) {
      filter(this.canvas2imgData(canvas), cb, config);
    } else {
      cb();
    }
  };

  utils.pleaseFilter = function (name, canvas, config) {
    return new Promise(
      function (resolve, reject) {
        var filter = this.getFilter(name),
          c = config || {};

        canvas = canvas || this.getCanvas();
        c.reject = reject;
        if (filter) {
          if (canvas.data) {
            filter(canvas, resolve, c);
          } else {
            filter(this.canvas2imgData(canvas), resolve, c);
          }
        } else {
          reject();
        }
      }.bind(this));
  };

  utils.registerBlender = function (name, blender) {
    this.blenders[name] = blender;
  };

  utils.getBlender = function (name) {
    return this.blenders[name];
  };

  utils.getBlenderNames = function () {
    return Object.keys(this.blenders);
  };

  utils.doBlend = function (name, canvas, background, cb, config) {
    var blender = this.getBlender(name);

    canvas = canvas || this.getCanvas();

    if (blender) {
      blender(this.canvas2imgData(canvas), background, cb, config);
    } else {
      cb();
    }
  };

  utils.pleaseBlend = function (name, canvas, background, config) {
    return new Promise(
      function (resolve, reject) {
        var blender = this.getBlender(name);

        canvas = canvas || this.getCanvas();

        if (blender) {
          if (canvas.data) {
            blender(canvas, background, resolve, config);
          } else {
            blender(this.canvas2imgData(canvas), background, resolve, config);
          }
        } else {
          reject();
        }
      }.bind(this));
  };

  utils.createWebcam = function (placeholder, id, width, height) {
    var webcam,
      placeholderEl;

    // check webRTC support
    if (!navigator.getUserMedia) {
      return null;
    }

    webcam = document.createElement('video');
    webcam.id = id || 'webcam';
    webcam.width = width || 640;
    webcam.height = height || 480;

    placeholder = placeholder || 'webcamHolder';
    placeholderEl = typeof placeholder === 'string' ? document.getElementById(placeholder) : placeholder;

    try {
      placeholderEl.appendChild(webcam);
      this.STATE.webcamEl = webcam;
    } catch (e) {
      console.error('Webcam creation failed: ' + e);
    }

    return webcam;
  };

  utils.createCanvas = function (placeholder, id, width, height) {
    var canvas = document.createElement('canvas'),
      placeholderEl;

    canvas.id = id || 'canvas';
    canvas.width = width || 640;
    canvas.height = height || 480;

    placeholder = placeholder || 'canvasHolder';
    placeholderEl = typeof placeholder === 'string' ? document.getElementById(placeholder) : placeholder;

    try {
      placeholderEl.appendChild(canvas);
      this.STATE.canvasEl = canvas;
    } catch (e) {
      console.error('Canvas creation failed: ' + e);
    }

    return canvas;
  };

  utils.createImageInput = function (placeholder, id) {
    var input = document.createElement('input'),
      placeholderEl;

    input.id = id || 'imageInput';
    input.type = 'file';
    input.accept = 'image/*';
    input.capture = 'camera';
    input.placeholder = 'Take a photo!';

    placeholder = placeholder || 'imageInputHolder';
    placeholderEl = typeof placeholder === 'string' ? document.getElementById(placeholder) : placeholder;

    try {
      placeholderEl.appendChild(input);
      this.STATE.inputEl = input;
    } catch (e) {
      console.error('Image input creation failed: ' + e);
    }

    return input;
  };

  utils.initWebcam = function (webcam) {
    // check webRTC support
    if (!navigator.getUserMedia) {
      return null;
    }

    webcam = webcam || this.getWebcam();

    navigator.getUserMedia({
        video: true
      },
      utils.webcamSuccess.bind(utils),
      function (err) {
        console.log('Webcam initialization failed: ' + err);
      }
    );
  };

  utils.webcamSuccess = function (stream) {
    var video = this.getWebcam();

    video.autoplay = true;
    video.src = window.URL.createObjectURL(stream);

    video.addEventListener('playing', this.videoPlayingCB.bind(this));
  };

  utils.videoPlayingCB = function () {
    setTimeout(function () {
      var video = utils.getWebcam();

      if (video.width !== video.videoWidth || video.height !== video.videoHeight) {
        video.width = video.videoWidth;
        video.height = video.videoHeight;
      }

    }, 100);
  };

  utils.getWebcam = function () {
    return this.STATE.webcamEl;
  };
  utils.getCanvas = function () {
    return this.STATE.canvasEl;
  };
  utils.getInput = function () {
    return this.STATE.inputEl;
  };

  utils.video2canvas = function (video, canvas, callback) {
    video = video || this.getWebcam();
    canvas = canvas || this.getCanvas();

    canvas.width = video.width;
    canvas.height = video.height;

    canvas.getContext('2d').drawImage(video, 0, 0, video.width, video.height, 0, 0, canvas.width, canvas.height);

    if (callback) {
      callback(canvas);
    }
  };

  utils.image2canvas = function (image, canvas, callback) {
    var img = new Image();

    canvas = canvas || this.getCanvas();
    img.src = image;

    img.onload = function () {
      utils.img2canvas(img, canvas, callback);
    };
  };

  utils.img2canvas = function (img, canvas, callback) {
    canvas = canvas || this.getCanvas();

    canvas.width = img.width;
    canvas.height = img.height;
    canvas.getContext('2d').drawImage(img, 0, 0);

    if (callback) {
      callback(canvas);
    }
  };

  utils.input2canvas = function (input, canvas, mWidth, mHeight, callback) {
    var file;

    canvas = canvas || this.getCanvas();
    input = input || this.getInput();

    if (!input.files || !input.files.length) {
      return null;
    }

    file = input.files[0];

    loadImage.parseMetaData(
      file,
      function (data) {
        // exif info is available here
        loadImage(
          file,
          function (img) {
            console.time('loadImage');
            utils.img2canvas(img, canvas, callback);
            console.timeEnd('loadImage');
          }, {
            canvas: true,
            orientation: data && data.exif && data.exif.get('Orientation'),
            maxWidth: mWidth,
            maxHeight: mHeight
          }
        );
      }
    );

  };

  utils.canvas2imgData = function (canvas) {
    var ctx;

    canvas = canvas || this.getCanvas();

    ctx = canvas.getContext("2d");

    return ctx.getImageData(0, 0, canvas.width, canvas.height);
  };

  fc.utils = utils;

  /**
   * A simple math function that calculates Euclidean distance
   * between two two-dimensional points.
   *
   * @param p1 Array of coordinates
   * @param p2 Array of coordinates
   *
   * @return distance
   */
  utils.distance = function (p1, p2) {
    return Math.sqrt(
      Math.pow(p1[0] - p2[0], 2) +
      Math.pow(p1[1] - p2[1], 2)
    );
  };

  utils.dump = function (imgData, canvasId, width, height) {
    var id = canvasId || utils.DEBUG_CANVAS,
    canvas = document.getElementById(id),
      ctx, idata;

    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.id = id;
      document.body.appendChild(canvas);
    }
    ctx = canvas.getContext('2d');

    if (imgData.getContext) {
      canvas.width = imgData.width;
      canvas.height = imgData.height;
      ctx.drawImage(imgData, 0, 0);
      return ctx;
    } else {
      if (imgData.rect) {
        idata = imgData.getImageData(0, 0, imgData.canvas.width, imgData.canvas.height);
      } else if (imgData.length) {
        let i, length = imgData.length;
        idata = ctx.createImageData(width, height);
        for (i = 0; i < length; i++) {
          idata.data[i] = imgData[i];
        }
      } else {
        idata = imgData;
      }
      canvas.width = idata.width;
      canvas.height = idata.height;
      ctx.putImageData(idata, 0, 0);
      return ctx;
    }
  };

}(FakeCation));
